import awsConfigProd from './aws-exports.prod'
import awsConfig from './aws-exports'

const prodDomains = [
    'https://webview.waterguru.com',
    'https://webview.waterguru-prod.com'
]

const MODE = (~prodDomains.indexOf(location.origin) && process.env.NODE_ENV === 'production') ? 'prod' : 'qa'
const PREFIX = (MODE === 'prod') ? 'prod-' : 'qa-'
const CONFIG = (MODE === 'prod') ? awsConfigProd : awsConfig

export { PREFIX }
export default CONFIG
